import { ViewFactory } from 'src/3rds/cube-react'

import { CampanhaScope } from '../Campanha.scopes'
import CampanhaView from './Campanha.view'

export { CampanhaView } from './Campanha.view'

export function registerViews(rv = ViewFactory.register) {
    rv(CampanhaScope, CampanhaView)
}
